<template>
  <div>
    <div class="row">
      <div class="col-sm-3" style="margin-top: 10px" v-bind:key="todo.id" v-for="todo in img">
        <!-- <button class="btn btn-dark" @click="getdata">GetData</button> -->
        <div class="card img-fluid" @click="OpenModal(todo.urls.small)">
          <img class="card-img-top imgheight" v-bind:src="todo.urls.small" alt="Card image cap" />
        </div>
      </div>
      <div v-if="count == 0" class="col-sm-12 col-md-12 col-lg-12 col-12 alert-height">
        <div class="alert alert-danger text-center">
          <strong>No Images found</strong>
        </div>
      </div>
    </div>
    <div>
      <Modal v-if="showModal" v-bind:image="image" @close="CloseModal" />
    </div>
  </div>
</template>

<script>
import Modal from "./Modal";

export default {
  name: "ImageList",
  components: {
    Modal
  },
  props: ["img", "count"],
  data() {
    return {
      showModal: false,
      image: ""
    };
  },
  methods: {
    OpenModal(img) {
      this.showModal = true;
      this.image = img;
      document.documentElement.style.overflowY = "hidden";
    },
    CloseModal() {
      document.documentElement.style.overflowY = "visible";
      this.showModal = false;
    }
  }
};
</script>

<style>
.imgheight {
  height: 250px;
}
.alert-height {
  margin-top: 10px;
}
</style>